// This file is generated by pnpm icons:generate. Do not edit.

import {CircleX_Stroke2_Corner0_Rounded as CanonicalCircleX_Stroke2_Corner0_Rounded} from './Circle'

/** @deprecated Import CircleX_Stroke2_Corner0_Rounded from `#/components/icons/Circle` instead. */
export const CircleX_Stroke2_Corner0_Rounded =
  CanonicalCircleX_Stroke2_Corner0_Rounded
